export default "__VITE_ASSET__BKK9XRXL__"